import gettext from '@sdk/lang/gettext';

import { MessagePost as MessagePostType } from '@web/conversations/types/Message';
import { MessageAuthor } from '@web/conversations/Message/MessageAuthor/MessageAuthor';
import {
  MessageInfoText,
  MessageLayout,
  MessageWrapper,
} from '@web/conversations/Message/MessageLayout/MessageLayout';

type Props = {
  message: MessagePostType;
  withHeader: boolean;
};
export const MessagePostDeleted = ({ message, withHeader }: Props) => (
  <>
    {withHeader && <MessageAuthor author={message.author} />}

    <MessageLayout>
      <MessageWrapper>
        <MessageInfoText>{gettext('message deleted')}</MessageInfoText>
      </MessageWrapper>
    </MessageLayout>
  </>
);
